import { render, staticRenderFns } from "./FloatMenu.vue?vue&type=template&id=5c3ba27b&scoped=true"
import script from "./FloatMenu.vue?vue&type=script&lang=js"
export * from "./FloatMenu.vue?vue&type=script&lang=js"
import style0 from "./FloatMenu.vue?vue&type=style&index=0&id=5c3ba27b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c3ba27b",
  null
  
)

export default component.exports